import React, { useState } from 'react';
import RightNavBar from './RightNavBar';
import InfoCard from './InfoCard';
import InfoCardContent from './InfoCardContent';
import FilterList from './FilterList';
import './Experience.css';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";

function Experience() {
    const responsiveNew = {
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 2,
          slidesToSlide: 2 // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
          slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          slidesToSlide: 1 // optional, default to 1.
        }
    };

    const adobeContent = ["Front-end Software Engineering Internship", "July 2021 - September 2021 (10 weeks)", "ReactJS, JavaScript"];
    const adobeMoreInfo = ["Managing the migration of the Adobe Cloud Manager interface from React Spectrum v2 to React Spectrum v3", "Helping with front-end developement on a company hackathon project", "Learning and putting into practice Agile and Scrum workflows"]
    const adobeCard = <InfoCard 
        headerImg={"images/logo-adobe.png"} 
        content={InfoCardContent(adobeContent)} 
        tag="Internship"
        more={<ul>{adobeMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Job Description" 
    />;

    const cguiContent = ["Research Project in AR", "January 2020 - April 2020", "Unity, ARCore, Mapbox, Vuforia", "A project about the use of haptic feedback in journalism", "Aimed to improve media experiences for people with visual impairments"];
    const cguiMoreInfo = ["Developed an AR mobile app that allows the user to feel differences between data values through vibration", "The data sets used are the numbered of insured people in different US states", "The app supports a 3D map and a 2D one, both of which trigger haptic responses when being touched through the screen or seen (through raycasting) by the phone"];
    const cguiImages = ["images/3dmap1.jpg", "images/3dmap2.jpg", "images/raycast1.jpg", "images/raycast2.jpg"];
    const cguiCard = <InfoCard 
        headerImg={"images/logo_cgui.png"} 
        content={
            <>
                {InfoCardContent(cguiContent)}
                <Carousel 
                    responsive={responsiveNew}
                    swipeable={true}
                    draggable={true}
                    ssr={true}
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={5500}
                    customTransition="transform ease-in-out 1000ms"
                    transitionDuration={1000}
                    containerClass="carousel-container"
                    itemClass="carousel-img"
                    centerMode={false}
                >
                    {cguiImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </>
        }
        tag="Research"
        more={<ul>{cguiMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Job Description"
    />

    const btContent = ["Bachelor Thesis Research", "Computer Graphics Team, CS Lab of Ecole Polytechnique", "February 2020 - April 2020", "MATLAB, C++", "2D Voronoi Diagram Applications: Branching Structures and Crack Patterns Synthesis"];
    const btMoreInfo = ["Analyzed previous methods and introduced a new algorithm to refine the medial axis approximation of a curve", "Employed MATLAB and C++ to synthesize simplified branching structures or crack patterns utilizing medial axes of closed curves and Depth First Search based Voronoi diagram maze generation"];
    const btCard = <InfoCard 
        headerImg={"images/logo_lix.png"} 
        content={InfoCardContent(btContent)} 
        tag="Research"
        more={<ul>{btMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Job Description"
    />

    const nycContent = ["Research Assistant in Web Design and Development", "Center for Spatial Research and Department of History", "November 2021 - December 2021", "Vue.js, Figma, Mapbox", "Mapping Historical New York Project"];
    const nycMoreInfo = ["Building wireframes and prototypes for new features", "Working on adapting the website for mobile and tablet versions"];
    const nycCard = <InfoCard 
        headerImg={"images/gsapp_logo.png"} 
        content={InfoCardContent(nycContent)} 
        tag="Research"
        more={<ul>
            <li className="more-info-items">
                <i className="fa fa-angle-right" />  Working alongside researchers, designers and web developers on the <a href="https://mappinghny.com/?lng=-73.9760&lat=40.7220&zoom=12.50&maps=%5B%7B%22center%22%3A%7B%22lng%22%3A-73.976,%22lat%22%3A40.722%7D,%22demographicOpacity%22%3A1,%22demographicsFilters%22%3A%7B%7D,%22filters%22%3A%7B%7D,%22layers%22%3A%5B%7B%22id%22%3A%22dwellings-dot-density-birthplace%22%7D%5D,%22rasterOpacity%22%3A1,%22year%22%3A%221880%22,%22zoom%22%3A12.5%7D%5D&rasterOpacity0=1" target="_blank" className="bold-link-exp">Mapping Historical New York project</a>
            </li>
            {nycMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}
            </ul>}
        moreInfo="Job Description"
    />
    
    const taContent = ["Teaching Assistant", "Introduction to Contextual Design for Technology", "September 2021 - December 2021"]
    const taCard = <InfoCard 
        headerImg={"images/logo_barnard.png"} 
        content={InfoCardContent(taContent)} 
        tag="Part-time"
        more={null}
    />

    const experienceFilter = {
        "All": [adobeCard, cguiCard, nycCard, btCard, taCard],
        "Internships": [adobeCard],
        "Research": [nycCard, cguiCard, btCard],
        "Others": [taCard],
    }
    const filters = Object.keys(experienceFilter);

    const [ filter, setFilter ] = useState("All");
    const chooseFilter = (item) => {
        setFilter(item);
    }

    return (
        <>
            <div className="page-content">
                {experienceFilter[filter]}
            </div>
            <RightNavBar>
                <div className="question-caption italic-element">
                    Click to filter the results:
                </div>
                <FilterList filters={filters} onFilterClick={chooseFilter} key="experience-rnb" />
            </RightNavBar>
        </>
    )
}

export default Experience;